/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';
import {ServiceLocale} from './ServiceLocale';

/**
 * The ServiceUpdateLocaleResponse model module.
 * @module model/ServiceUpdateLocaleResponse
 * @version version not set
 */
export class ServiceUpdateLocaleResponse {
  /**
   * Constructs a new <code>ServiceUpdateLocaleResponse</code>.
   * @alias module:model/ServiceUpdateLocaleResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdateLocaleResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdateLocaleResponse} obj Optional instance to populate.
   * @return {module:model/ServiceUpdateLocaleResponse} The populated <code>ServiceUpdateLocaleResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdateLocaleResponse();
      if (data.hasOwnProperty('locale'))
        obj.locale = ServiceLocale.constructFromObject(data['locale']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ServiceLocale} locale
 */
ServiceUpdateLocaleResponse.prototype.locale = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceUpdateLocaleResponse.prototype.state = undefined;


